e4.checkout = {
    debug: false,
    validationOptions: {
        normalizer: function( value ) {
            return jQuery.trim( value );
        }
    },
    init: function () {
        e4.checkout.jCheckout = jQuery('.js-e-checkout');
        e4.checkout.event     = e4.util.registerEvents('orderupdate orderupdated shippingchanged paymentchanged', 'checkout');
        jQuery.when.apply(jQuery, [
            e4.util.require.js(e4.settings.require.jQueryValidate)
        ]).then(function () {
            e4.checkout.jCheckout.find('form').validate(e4.checkout.validationOptions);
            e4.checkout.bindEvents();
            e4.checkout.loadTermsAndConditions();
            e4.checkout.update([], false);
        });

        if (jQuery('.js-e-checkout-receipt').length === 1) {
            e4.checkout.activeCampaign.init();
        }
    },
    util: {
        ajax: function (objAjaxSettings, fnCallback) {
            e4.util.debug([
                'ajax settings',
                objAjaxSettings,
                'callback',
                fnCallback
            ], e4.checkout.debug);
            return jQuery.ajax(jQuery.extend({
                method: 'POST'
            }, objAjaxSettings)).done(function (data) {
                if (typeof fnCallback === 'function') {
                    fnCallback(data);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.error(jqXHR, textStatus, errorThrown);
            }).always(function () {
                jQuery('.js-e-loading-overlay').removeClass('is-loading');
            });
        },
        address: {
            defaultMappingKeys: [
                'Name',
                'Company',
                'Address',
                'Address2',
                'Zip',
                'City',
                'Country',
                'Phone'
            ],
            hasAlternativeDeliveryAddress: function () {
                return jQuery('.js-e-checkout-has-alternative-address').val() === 'true';
            },
            hasUserAddress: (function () {
                return jQuery('.js-e-checkout-set-user-address-as-delivery-address').not('.js-e-checkout-user-billing-address').filter(':checked').length > 0;
            })(),
            setHasAlternativeDeliveryAddress: function (boolHasAlternativeAddress) {
                jQuery('.js-e-checkout-has-alternative-address').val(boolHasAlternativeAddress === true ? 'true' : '');
            },
            mapUserToDelivery: function (domInput) {
                e4.util.debug('address mapUserToDelivery', e4.checkout.debug);
                var jAddressData   = jQuery(domInput).closest('label').find('.js-e-checkout-user-address-item-data'),
                    objAddressMap  = {},
                    arrAddressKeys = jQuery.merge(['Email'], e4.checkout.util.address.defaultMappingKeys);
                arrAddressKeys.forEach(function (strAddressKey) {
                    objAddressMap['EcomOrderDelivery' + strAddressKey] = jAddressData.find('[data-item="EcomOrderDelivery' + strAddressKey + '"]').text();
                });
                e4.checkout.util.address.doMapping(objAddressMap);
            },
            clearDeliveryAddress: function () {
                var arrAddressKeys = jQuery.merge(['Email'], e4.checkout.util.address.defaultMappingKeys);
                arrAddressKeys.forEach(function (strAddressKey) {
                    e4.util.debug([
                        'Clear Delivery',
                        strAddressKey
                    ], e4.checkout.debug);
                    jQuery('[name="EcomOrderDelivery' + strAddressKey + '"]').val('');
                });
            },
            clearBillingAddress: function () {
                var jBillingAddressForm = jQuery('.js-e-checkout-billing-address');
                jBillingAddressForm.find('input[type="text"], input[type="number"]').val('');
                jBillingAddressForm.find('input[type="checkbox"]').prop('checked', false);
            },
            mapAddresses: function (strFromAddressType, strToAddressType, arrAddressKeys) {
                if (arrAddressKeys === undefined) {
                    arrAddressKeys = e4.checkout.util.address.defaultMappingKeys;
                }
                arrAddressKeys.forEach(function (strAddressKey) {
                    var strFromAddresValue        = jQuery('[name="EcomOrder' + strFromAddressType + strAddressKey + '"]').val(),
                        strToAddressTypeInputName = 'EcomOrder' + strToAddressType + strAddressKey;
                    e4.util.debug([
                        'address mapAddresses',
                        strToAddressTypeInputName,
                        strFromAddresValue
                    ], e4.checkout.debug);
                    jQuery('[name="' + strToAddressTypeInputName + '"]').val(strFromAddresValue !== undefined ? strFromAddresValue : '');
                });
            },
            doMapping: function (objAddressMap) {
                jQuery.each(objAddressMap, function (strAddressKey, objValue) {
                    e4.util.debug([
                        'address doMapping',
                        strAddressKey,
                        objValue
                    ], e4.checkout.debug);
                    jQuery('[name="' + strAddressKey + '"]').val(objValue);
                });
            }
        }
    },
    bindEvents: function () {
        //Form Events
        jQuery('.js-e-checkout-form').on('keydown', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                if (event.target.name === 'EspressoParcelShopZip' || event.target.name === 'EspressoParcelShopAddress') {
                    e4.checkout.parcelshop.search();
                }
            }
        });
        //Address Input Events
        e4.checkout.jCheckout.on('change', '.js-e-checkout-change-delivery-country', function () {
            e4.checkout.update([
                e4.checkout.blocks.customer,
                e4.checkout.blocks.shipping,
                e4.checkout.blocks.payment,
                e4.checkout.blocks.orderSummery,
                e4.checkout.blocks.orderLineSummery
            ]);
        }).on('change', '.js-e-checkout-change-billing-country', function () {
            if (e4.checkout.util.address.hasAlternativeDeliveryAddress() === false) {
                e4.checkout.util.address.mapAddresses('Customer', 'Delivery');
            }
            e4.checkout.update([
                e4.checkout.blocks.customer,
                e4.checkout.blocks.shipping,
                e4.checkout.blocks.payment,
                e4.checkout.blocks.orderSummery,
                e4.checkout.blocks.orderLineSummery
            ]);
        }).on('change', '.js-e-checkout-has-alternative-delivery, .js-e-checkout-toggle-user-alternative-address', function (event) {
            if (event.target.checked === true) {
                e4.checkout.util.address.setHasAlternativeDeliveryAddress(true);
                e4.checkout.util.address.clearDeliveryAddress();
            } else {
                e4.checkout.util.address.setHasAlternativeDeliveryAddress(false);
                e4.checkout.util.address.mapAddresses('Customer', 'Delivery');
            }
        }).on('change', '.js-e-checkout-delivery-address input, .js-e-checkout-delivery-address select', function () {
            e4.checkout.update([
                e4.checkout.blocks.customer
            ], false);
        })/*.on('change', '.js-e-checkout-billing-address input, .js-e-checkout-billing-address select', function () {
            if (jQuery('.js-e-checkout-set-user-address-as-delivery-address.js-e-checkout-user-billing-address').prop('checked') === true) {
                e4.checkout.util.address.mapAddresses('Customer', 'Delivery');
            }
            e4.checkout.update([
                e4.checkout.blocks.shipping
            ], false);
        })*/.on( 'click', '.js-e-checkout-next-step', function () {
            if( e4.checkout.jCheckout.find('form').valid() === true ) {
                
                //GA4 add_shipping_method
                var objOrderlineItems = window.objOrderlineItems.ecommerce.items;
                var objGA4ShipphingInfoDatalayer = e4.gtm.ecom.getShippingInfo();
                objGA4ShipphingInfoDatalayer.ecommerce.items.push( objOrderlineItems );
                objGA4ShipphingInfoDatalayer.ecommerce.shipping_tier = jQuery('.js-e-checkout').data('ga4-shipping-method');
                dataLayer.push({ ecommerce: null });
                e4.gtm.pushDataLayer( objGA4ShipphingInfoDatalayer );

                //GA4 add_payment_method
                var objGA4PaymentInfoDatalayer = e4.gtm.ecom.getPaymentInfo();
                objGA4PaymentInfoDatalayer.ecommerce.items.push( objOrderlineItems );
                objGA4PaymentInfoDatalayer.ecommerce.payment_type = jQuery('.js-e-checkout-set-payment-method:checked').data( 'payment-description' );
                dataLayer.push({ ecommerce: null });
                e4.gtm.pushDataLayer( objGA4PaymentInfoDatalayer );
            }
            
        });

        //Shipping events
        e4.checkout.jCheckout.on('change', '.js-e-checkout-set-shipping-method', function (event) {
            e4.checkout.util.address.clearDeliveryAddress();
            if (jQuery(event.target).is('.is-service-point') === false) {
                var jUserAddresses = e4.checkout.jCheckout.find('.js-e-checkout-set-user-address-as-delivery-address');
                jQuery('.js-e-checkout-shippingmethod-parcelshop-shop-id-input').val('');
                jQuery('.js-e-checkout-shippingmethod-parcelshop-search-form').html('');
                if (jUserAddresses.length > 0) {
                    e4.checkout.util.address.mapUserToDelivery(jUserAddresses.get(0));

                } else {
                    e4.checkout.util.address.mapAddresses('Customer', 'Delivery');
                }
            } else {
                e4.checkout.util.address.setHasAlternativeDeliveryAddress(false);
            }
            e4.checkout.update([
                e4.checkout.blocks.customer,
                e4.checkout.blocks.shipping,
                e4.checkout.blocks.orderSummery,
                e4.checkout.blocks.orderLineSummery
            ]);
        }).on('change', '.js-e-checkout-shippingmethod-parcelshop-result-item-input', function (event) {
            var jsonParcelShops = JSON.parse(jQuery(event.target).closest('.js-e-checkout-shippingmethod-parcelshop-result-item').find('.js-e-checkout-parcelshop-data').html());
            jQuery('.js-e-checkout-shippingmethod-parcelshop-shop-id-input').val(event.target.value);
            e4.checkout.parcelshop.set(jsonParcelShops);
        }).on('click', '.js-e-search-parcelshop-btn', function () {
            e4.checkout.parcelshop.search();
        }).on('shown.bs.collapse', '.js-e-checkout-delivery-address', function (event) {
            //Fix for nested collapse-events - only trigger event on js-e-checkout-delivery-address
            if (event.target === event.currentTarget) {
                e4.checkout.update([
                    e4.checkout.blocks.customer,
                    e4.checkout.blocks.shipping
                ], false);
            }

        });
        //Payment events
        e4.checkout.jCheckout.on('change', '.js-e-checkout-set-payment-method', function () {
            e4.checkout.update([
                e4.checkout.blocks.payment,
                e4.checkout.blocks.orderSummery,
                e4.checkout.blocks.orderLineSummery
            ], false);
        });
        //Approve events
        e4.checkout.jCheckout.on('change', '.js-e-checkout-customer-accept', function (event) {
            jQuery('.js-e-checkout-customer-accept').prop('checked', event.target.checked);
            if (e4.checkout.util.address.hasAlternativeDeliveryAddress() === false && e4.checkout.parcelshop.hasShippingProvider === false && e4.checkout.util.address.hasUserAddress === false) {
                e4.checkout.util.address.mapAddresses('Customer', 'Delivery');
            }
            e4.checkout.update([], false);
        }).on('click', '.js-e-checkout-accept-terms-and-conditions-btn', function () {
            jQuery('.js-e-checkout-customer-accept').prop('checked', true).first().trigger('change');
        });
        /*
        jQuery(window).on('beforeunload', function(){
            if (e4.checkout.util.address.hasAlternativeDeliveryAddress() === false && e4.checkout.parcelshop.hasShippingProvider === false && e4.checkout.util.address.hasUserAddress === false) {
                e4.checkout.util.address.mapAddresses('Customer', 'Delivery');
            }
        });
         */
        
        //User events
        e4.checkout.jCheckout.on('change', '.js-e-checkout-set-user-address-as-delivery-address', function (event) {
            var jDeliveryAddress = jQuery('.js-e-checkout-delivery-address');
            e4.checkout.util.address.setHasAlternativeDeliveryAddress(false);
            e4.checkout.util.address.clearDeliveryAddress();
            e4.checkout.util.address.mapUserToDelivery(event.target);
            jDeliveryAddress.collapse('hide');
            e4.checkout.update([
                e4.checkout.blocks.customer,
                e4.checkout.blocks.shipping,
                e4.checkout.blocks.payment,
                e4.checkout.blocks.orderSummery,
                e4.checkout.blocks.orderLineSummery
            ]);
        }).on('change', '.js-e-checkout-toggle-user-alternative-address', function (event) {
            var jDeliveryAddress = jQuery('.js-e-checkout-delivery-address');
            if (event.target.checked) {
                e4.checkout.util.address.setHasAlternativeDeliveryAddress(true);
                e4.checkout.util.address.clearDeliveryAddress();
                jQuery('.js-e-checkout-set-user-address-as-delivery-address').filter(':checked').prop('checked', false);
                jDeliveryAddress.collapse('show');
            } else {
                e4.checkout.util.address.setHasAlternativeDeliveryAddress(false);
                jDeliveryAddress.collapse('hide');
            }

        });

        //Custom events

        e4.checkout.jCheckout.on('change', '.js-babydan-toggle-active-campaign', function (event) {
            e4.checkout.util.ajax({
                data: {
                    ActiveCampaignSignup: event.target.checked ? 'yes' : ''
                }
            });
        });
    },
    update: function (arrBlocks, boolShowLoader) {
        if (boolShowLoader === undefined) {
            boolShowLoader = true;
        }
        e4.checkout.jCheckout.trigger('e4.checkout.event.orderupdate');
        e4.checkout.util.ajax({
            data: e4.checkout.jCheckout.find('.js-e-checkout-form').serialize(),
            beforeSend: function () {
                if (boolShowLoader === true) {
                    jQuery('.js-e-loading-overlay').addClass('is-loading');
                }
            }
        }, function (strHtml) {
            var jHtml = jQuery(strHtml);
            e4.util.debug([
                'xhr update done',
                'updating blocks',
                arrBlocks
            ], e4.checkout.debug);
            e4.checkout.updateBlocks(arrBlocks, jHtml);
            e4.checkout.jCheckout.trigger('e4.checkout.event.orderupdated');
        });
    },
    blocks: {
        customer: 'customer',
        shipping: 'shipping',
        payment: 'payment',
        orderSummery: 'orderSummery',
        orderLineSummery: 'orderLineSummery'
    },
    updateBlocks: function (arrBlocks, jHtml) {
        arrBlocks.forEach(function (strBlockKey) {
            var jCurrentContainer = jQuery('.js-e-checkout-block-container[data-key="' + strBlockKey + '"]'),
                jUpdatedContent   = jHtml.find('.js-e-checkout-block-container[data-key="' + strBlockKey + '"]');
            if (jCurrentContainer.length > 0) {
                jCurrentContainer.html(jUpdatedContent.html());
            }
            e4.util.debug([
                'updated block',
                strBlockKey
            ], e4.checkout.debug);
        });
    },
    parcelshop: {
        hasShippingProvider: (function () {
            return jQuery('.js-e-checkout-has-shipping-provider').val() === 'True';
        })(),
        set: function (jsonParcelshop) {
            var objAddressMap = {
                EcomOrderDeliveryName: jsonParcelshop.name,
                EcomOrderDeliveryAddress: jsonParcelshop.address,
                EcomOrderDeliveryZip: jsonParcelshop.zip,
                EcomOrderDeliveryCity: jsonParcelshop.city
            };
            e4.checkout.util.address.clearDeliveryAddress();
            e4.checkout.util.address.doMapping(objAddressMap);
            e4.checkout.update([
                e4.checkout.blocks.customer,
                e4.checkout.blocks.shipping,
                e4.checkout.blocks.payment,
                e4.checkout.blocks.orderSummery,
                e4.checkout.blocks.orderLineSummery
            ]);
        },
        search: function () {
            e4.checkout.util.ajax({
                data: e4.checkout.jCheckout.find('.js-e-checkout-form').serialize(),
                beforeSend: function () {
                    jQuery('.js-e-loading-overlay').addClass('is-loading');
                }
            }, function (strHtml) {
                var jHtml = jQuery(strHtml);
                e4.checkout.updateBlocks([
                    e4.checkout.blocks.customer,
                    e4.checkout.blocks.shipping
                ], jHtml);

            });
        }
    },
    loadTermsAndConditions: function () {
        e4.checkout.util.ajax({
            method: 'GET',
            cache: true,
            url: e4.settings.ecom.checkout.termsAndConditions,
            dataType: 'html',
            beforeSend: null
        }, function (strHtml) {
            strHtml = jQuery(strHtml).find('.js-e-content').html();
            jQuery('.js-e-checkout-modal-terms-and-conditions').replaceWith(strHtml);
        });
    },
    activeCampaign: {
        init: function () {
            e4.checkout.activeCampaign.bindEvents();
        },
        bindEvents: function () {
            var jActiveCampaing = jQuery('.js-babydan-active-campaign-receipt-form');
            if (jActiveCampaing.length === 1) {
                if (jActiveCampaing.find('form').length === 1) {
                    e4.checkout.activeCampaign.moveInfoToForm(jActiveCampaing);
                } else {
                    jActiveCampaing.one('DOMSubtreeModified', function () {
                        e4.checkout.activeCampaign.moveInfoToForm(jActiveCampaing);
                    });
                }
            }
        },
        moveInfoToForm: function (jActiveCampaing) {
            jActiveCampaing.find('input[name="fullname"]').val(jActiveCampaing.data('customerName'));
            jActiveCampaing.find('input[name="email"]').val(jActiveCampaing.data('customerEmail'));
            jActiveCampaing.find('input[data-name="gdpr"]').prop('checked', true);
            e4.checkout.activeCampaign.submitForm(jActiveCampaing);
        },
        submitForm: function (jActiveCampaing) {
            var jForm = jActiveCampaing.find('form');
            jQuery.ajax({
                url: jForm.attr('action'),
                crossDomain: true,
                dataType: 'jsonp',
                method: jForm.attr('method'),
                data: jForm.serialize()
            });
        }
    }
};
